export default "__VITE_ASSET__DebD3SCu__"